/** Service Desk console: mga return, pagkukumpuni at warranty replacement (RMA) sa asset at sa ticket (SD-S3-10). */
export const serviceRmas = {
  progress: "Progreso ng return",
  staffOnly: "Para sa staff lang",
  withManufacturer: "Nasa manufacturer",
  stop: { outcome: "Kinalabasan" },
  stepState: { done: "tapos na", current: "kasalukuyang hakbang", pending: "hindi pa" },
  status: {
    requested: "Hiniling",
    approved: "Aprubado",
    awaiting_return: "Naghihintay ng item",
    received: "Natanggap",
    inspected: "Nasuri",
    credited: "Na-credit",
    replaced: "Napalitan",
    repaired: "Naayos",
    rejected: "Tinanggihan",
    closed: "Sarado",
  },
  moveTo: {
    requested: "Ibalik sa hiniling",
    approved: "Aprubahan",
    awaiting_return: "Hingin ang item",
    received: "Markahang natanggap",
    inspected: "Itala ang inspeksyon",
    credited: "I-credit",
    replaced: "Palitan",
    repaired: "Naayos na",
    rejected: "Tanggihan",
    closed: "Isara",
  },
  direction: { from_customer: "Mula sa client", to_supplier: "Papunta sa manufacturer" },
  condition: { unused: "Hindi pa nagagamit", used: "Nagamit na", faulty: "May sira" },
  resolution: { repair: "Kumpunihin", replace: "Palitan", credit: "I-credit" },
  actor: { staff: "Team", contact: "Client", system: "System" },
  event: {
    created: "Ginawa ang RMA",
    status_changed: "Nagbago ang katayuan",
    updated: "Na-update ang detalye",
    tracking_added: "Nadagdag ang tracking reference",
    supplier_linked: "Naikabit ang RMA sa manufacturer",
    supplier_status: "Gumalaw ang RMA sa manufacturer",
  },
  errors: {
    not_allowed: "Hindi magagawa ng RMA ang galaw na iyon.",
    reason_required: "Maglagay ng dahilan para sa galaw na ito.",
    override_reason_required: "Sabi ng mga hint na kailangan pang suriin ang return na ito: ilagay ang dahilan kung bakit mo ito inaprubahan.",
    instructions_required: "Isulat ang mga tagubilin sa pagpapadala na babasahin ng client bago hingin ang item.",
    supplier_required: "Ilagay ang manufacturer na pagpapadalhan ng unit.",
    received_date_required: "Sabihin ang araw na dumating ang item.",
    inspection_required: "Isulat ang natuklasan sa inspeksyon.",
  },
  assetTab: { title: "Mga return para sa asset na ito" },
  list: {
    label: "Mga return",
    loading: "Nilo-load ang mga return",
    errorTitle: "Hindi ma-load ang mga return",
    errorBody: "Tingnan ang koneksyon at subukan muli. Walang nabago.",
    emptyTitle: "Walang return",
    emptyBody: "Lalabas dito ang return, pagkukumpuni o warranty replacement kapag nagsimula ng isa mula sa ticket.",
    rma: "RMA",
    item: "Item",
    ticket: "Ticket",
    status: "Katayuan",
    updated: "Na-update",
    open: "Buksan ang {{number}}",
  },
  create: {
    title: "Magsimula ng RMA",
    description: "Return, pagkukumpuni o warranty replacement para sa ticket {{ticket}}.",
    submit: "Gumawa ng RMA",
    done: "Nagawa ang {{number}}",
    direction: "Para kanino",
    fromCustomerHint: "Ibinabalik ng client ang item sa inyo.",
    toSupplierHint: "Ipinapadala ninyo ang unit sa manufacturer para sa RMA ng client.",
    asset: "Kagamitan",
    assetOther: "Hindi nakarehistrong kagamitan",
    product: "Pangalan ng produkto",
    productHint: "Kailangan kapag walang napiling kagamitan.",
    sku: "SKU",
    serial: "Serial number",
    quantity: "Dami",
    resolution: "Gustong kalabasan",
    condition: "Kondisyon",
    conditionUnknown: "Hindi alam",
    reason: "Ano ang problema",
    instructions: "Tagubilin sa pagpapadala para sa client",
    instructionsHint: "Babasahin ito ng client. Puwede mo itong isulat ngayon o kapag hiningi na ang item.",
    linked: "Para sa RMA ng client",
    linkedNone: "Hindi nakakabit",
    problems: { item: "Pumili ng kagamitan, o maglagay ng pangalan ng produkto.", quantity: "Mula 1 hanggang 999 ang dami." },
  },
  supplier: { name: "Manufacturer", reference: "Reference ng manufacturer", notes: "Mga tala para sa manufacturer" },
  eligibility: {
    title: "Pasok ba?",
    hintsOnly: "Mga hint lang; ikaw ang magpapasya.",
    warrantyEnd: "Matatapos ang warranty",
    purchased: "Binili",
    error: "Hindi nakuwenta ang mga hint. Puwede ka pa ring magpatuloy.",
    verdict: { eligible: "Mukhang pasok", review: "Kailangang suriin pa", unknown: "Kulang para masabi" },
    reason: {
      in_warranty: "May warranty pa ang kagamitan.",
      warranty_expiring: "Malapit nang matapos ang warranty.",
      warranty_expired: "Tapos na ang warranty.",
      warranty_unknown: "Hindi alam ang warranty.",
      no_asset: "Walang nakarehistrong kagamitang binanggit.",
      within_return_window: "Nasa loob ng {{days}} araw na return window.",
      outside_return_window: "Lampas sa {{days}} araw na return window.",
      no_purchase_date: "Walang petsa ng pagbili sa talaan.",
      used_item: "Nagamit na ang item, kaya hindi naaangkop ang return window.",
    },
    source: { asset: "mula sa talaan ng kagamitan", order: "mula sa kasaysayan ng order" },
  },
  drawer: {
    title: "{{number}}",
    titleLoading: "Return",
    loading: "Nilo-load ang RMA",
    clientSees: "Ito ang nababasa ng client: {{label}}",
    moves: "Ilipat ang RMA na ito",
    item: "Item",
    product: "Produkto",
    ticket: "Ticket",
    sku: "SKU",
    serial: "Serial number",
    quantity: "Dami",
    condition: "Kondisyon",
    resolution: "Gustong kalabasan",
    tracking: "Tracking reference",
    noTracking: "Hindi pa naidaragdag ng client",
    servesRma: "Back-office RMA para sa {{number}}.",
    supplierRmas: "Mga RMA sa manufacturer: {{numbers}}.",
    receivedOnLine: "Natanggap noong {{date}}.",
    details: "Pagpapadala at inspeksyon",
    instructions: "Tagubilin sa pagpapadala",
    instructionsHint: "Babasahin ito ng client.",
    staffOnlyHint: "Hindi kailanman nakikita ng client ang mga field na ito.",
    receivedOn: "Natanggap noong",
    fee: "Restocking fee",
    inspection: "Resulta ng inspeksyon",
    save: "I-save ang mga pagbabago",
    saved: "Nai-save ang {{number}}",
    timeline: "Timeline",
    timelineEmpty: "Wala pang naitala.",
    timelineError: "Hindi ma-load ang timeline.",
  },
  status_dialog: {
    title: "{{number}}: {{status}}",
    confirm: "Ilipat sa {{status}}",
    done: "{{status}} na ang {{number}}",
    required: "Kailangan ito para sa galaw.",
    review: "Sabi ng mga hint na kailangan pang suriin ang return na ito. Sabihin kung bakit mo ito inaprubahan.",
    reason: "Dahilan",
    overrideReason: "Bakit mo ito inaprubahan",
    instructions: "Tagubilin sa pagpapadala para sa client",
    instructionsHint: "Saan at paano ipapadala ang item. Babasahin ito ng client kapag hiningi na ang item.",
    supplier: "Manufacturer",
    receivedOn: "Araw na dumating ang item",
    inspection: "Ano ang natuklasan sa inspeksyon",
    fee: "Restocking fee (opsyonal)",
    feeHint: "Halaga sa piso na may hanggang dalawang decimal. Para sa impormasyon lang ito.",
    feeProblem: "Gumamit ng numerong tulad ng 250 o 250.50.",
    nothingNeeded: "Wala nang kailangan. Sasabihan ang client sa sarili nilang salita.",
    body: {
      requested: "Ibalik ang RMA sa hiniling.",
      approved: "Tanggapin ang hiling na return.",
      awaiting_return: "Sasabihan ang client kung saan ipapadala ang item.",
      received: "Itala na dumating ang item.",
      inspected: "Itala ang natuklasan sa inspeksyon.",
      credited: "I-credit ang client.",
      replaced: "Palitan ang item.",
      repaired: "Markahang naayos na.",
      rejected: "Tanggihan ang hiling; itatago ang dahilan.",
      closed: "Tapusin ang RMA. Hindi na ito mababago.",
    },
  },
} as const;
